const colors = {
  grey: "#757575",
  lightGrey: "#EEE",
  white: "#FFFFFF",
  black: "#1A1A1A",
  accent: "#0c3059",
  neonGreen: "#D6FFAA",
  fontColor: "#FFFFFF",
  yellow: "#FFE26A",
  lighYellow: "#FFF9BB",
  pink: "#FFEBFB",
  blue: "#D4FEFF",
  green: "#AAFFD3",
  peach: "#FFD9AA",
  cyan: "#00EE5F",
  purple: "#B658FF",
  darkgreen: "#6CA382",
  darkred: "#B82525",
  lightblue: "#37979D",
  lightgreen: "#95D554",
  orange: "#FF6D41",
  purple: "#B658FF",
  lightblue: "#37979D",
  dayblack: "#484545",
  neutral: "#C5A388",
  tealgreen: "#00EE5F",
  primary: "#95D554",
};

export default colors;
